<script>
    import twemoji from "twemoji";
    import {
        Badge
    } from "sveltestrap";

    import { _ } from 'svelte-i18n';
    
    import { useQuery } from '@sveltestack/svelte-query';
    const profilData = useQuery("profilData");
</script>


<span class="text-muted">{$_("components.ProfilAbout.About")} :</span><br />
{$_("components.ProfilAbout.InterestedBy.InterestedBy")} : 
{#if $profilData.data.interestedGender == "F"}
    {@html twemoji.parse($_("components.ProfilAbout.InterestedBy.F"))}
{:else}
    {@html twemoji.parse($_("components.ProfilAbout.InterestedBy.M"))}
{/if}<br />
{#if $profilData.data.profilAbout != null}
    {#if $profilData.data.profilAbout.search}
        {$_("components.ProfilAbout.Search.ISearch")} : {@html twemoji.parse($_("components.ProfilAbout.Search."+ $profilData.data.profilAbout.search))}
        <br />
    {/if}
    {#if $profilData.data.profilAbout.children}
        {$_("components.ProfilAbout.Children.Childrens")} : 
        {@html twemoji.parse($_("components.ProfilAbout.Children."+$profilData.data.profilAbout.children))}<br />
        {#if Number.isInteger($profilData.data.profilAbout.children_number) && $profilData.data.profilAbout.children_number > 0}
            {$_("components.ProfilAbout.Children.ChildrensNumbers")} : 
            {$profilData.data.profilAbout.children_number}<br />
        {/if}
    {/if}
    {#if $profilData.data.profilAbout.first_step}
        {$_("components.ProfilAbout.first_step.firstStep")} : 
        {$_("components.ProfilAbout.first_step."+$profilData.data.profilAbout.first_step)} <br />
    {/if}
    {#if $profilData.data.profilAbout.live_with}
        {$_("components.ProfilAbout.live_with.liveWith")} : 
        {$_("components.ProfilAbout.live_with."+$profilData.data.profilAbout.live_with)} <br />
    {/if}
    {#if $profilData.data.profilAbout.favorite_animal}
        {$_("components.ProfilAbout.favorite_animal.favoriteAnimal")} : 
        {$_("components.ProfilAbout.favorite_animal."+$profilData.data.profilAbout.favorite_animal)}<br />
    {/if}
    {#if $profilData.data.profilAbout.work}
        {$_("components.ProfilAbout.work")} : 
        {$profilData.data.profilAbout.work}<br />
    {/if}
    {#if $profilData.data.profilAbout.favorite_social_network}
        {$_("components.ProfilAbout.favorite_social_network.favoriteSocialNetwork")} : 
        {$_("components.ProfilAbout.favorite_social_network." + $profilData.data.profilAbout.favorite_social_network)}<br />
    {/if}
    {#if $profilData.data.profilAbout.favorite_music_style}
        {$_("components.ProfilAbout.favorite_music_style.favoriteMusicStyle")} : 
        {$_("components.ProfilAbout.favorite_music_style." + $profilData.data.profilAbout.favorite_music_style)}<br />
    {/if}
    {#if $profilData.data.profilAbout.languages}
        {$_("components.ProfilAbout.ISpeak")} :<br />
        {#each $profilData.data.profilAbout.languages as lang}
            <Badge class="mr-1">{@html twemoji.parse($_("components.ProfilAbout.languages." + lang))}</Badge>
        {/each}
    {/if}
{/if}